import(/* webpackMode: "eager" */ "/app/apps/platform-web/app/v2/v2.css");
;
import(/* webpackMode: "eager", webpackExports: ["ExperienceCampaignPage"] */ "/app/apps/platform-web/components/pages/ExperienceCampaignPage.tsx");
